import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-chevron-down",
  "use": "n-icon-chevron-down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"n-icon-chevron-down\">\n    <path d=\"M10 11.6983L5.64021 8.2318C5.21593 7.87824 4.58537 7.93556 4.2318 8.35984C3.87824 8.78412 3.93556 9.41468 4.35984 9.76825L9.35984 13.7682C9.73069 14.0773 10.2694 14.0773 10.6402 13.7682L15.6402 9.76825C16.0645 9.41468 16.1218 8.78412 15.7682 8.35984C15.4147 7.93556 14.7841 7.87824 14.3598 8.2318L10 11.6983Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol